module.exports = __webpack_public_path__ + "img/SoftwareCopyright_13.c1baefa8.png";